export const REVIEW_STATUS = {
  UNREVIEWED: 0,
  REVIEWING: 1,
  APPROVED: 2,
  REJECTED: 3,
  WITHDRAWN: 4,
  EXCEPTION: 5,
  AGENT_APPROVED: 6,
  REVOKED: 7,
};
// '審核狀態 0:未審核 1:審核中 2. 已通過 3. 已拒絕 4. 已撤回 5.異常 6.同意代理'
export const REVIEW_STATUS_TEXT = {
  [REVIEW_STATUS.UNREVIEWED]: "未審核",
  [REVIEW_STATUS.REVIEWING]: "審核中",
  [REVIEW_STATUS.APPROVED]: "已批准",
  [REVIEW_STATUS.REJECTED]: "已拒絕",
  [REVIEW_STATUS.WITHDRAWN]: "已撤回",
  [REVIEW_STATUS.EXCEPTION]: "異常",
  [REVIEW_STATUS.AGENT_APPROVED]: "同意代理",
  [REVIEW_STATUS.REVOKED]: "已撤銷",
};

export const ABNORMAL_STATUS = {
  0: "正常",
  1: "無附件",
  2: "附件錯誤",
  3: "無代理人",
  10: "已補件等待審核",
};

export const REVIEW_STATUS_COLOR = {
  [REVIEW_STATUS.UNREVIEWED]: "grey",
  [REVIEW_STATUS.REVIEWING]: "amber",
  [REVIEW_STATUS.APPROVED]: "green",
  [REVIEW_STATUS.REJECTED]: "red",
  [REVIEW_STATUS.WITHDRAWN]: "orange",
  [REVIEW_STATUS.EXCEPTION]: "red",
  [REVIEW_STATUS.AGENT_APPROVED]: "blue",
  [REVIEW_STATUS.REVOKED]: "purple",
};
// leave type
// 1	特休假
// 2	事假
// 3	病假
// 4	生理假
// 5	公傷病假
// 6	婚假
// 7	產檢假
// 8	產假
// 9	陪產檢及陪產假
// 10	喪假
// 11	公假
// 12	家庭照顧假
// 13	原住民族勞工歲時祭儀假
export const LEAVE_TYPE = {
  1: "特休假",
  2: "事假",
  3: "病假",
  4: "生理假",
  5: "公傷病假",
  6: "婚假",
  7: "產檢假",
  8: "產假",
  9: "陪產檢及陪產假",
  10: "喪假",
  11: "公假",
  12: "家庭照顧假",
  13: "原住民族勞工歲時祭儀假",
  14: "補休假",
  50: "天災停班",
};

export const APPLY_TYPE = {
  1: "請假申請",
  2: "加班申請",
  3: "調班申請",
  4: "補打卡申請",
  5: "出差申請",
  6: "外出申請",
  7: "離職申請",
  10: "留職停薪申請",
};

// export const ROLES = {
export const ROLES = ["superadmin", "consultant", "hr", "manager", "employee"];

export const ROLE_MAPPING = {
  superadmin: "管理員",
  consultant: "顧問",
  hr: "雇主/人資",
  manager: "主管",
  employee: "員工",
};

//     type: DataTypes.ENUM('待審核', '審核中', '審核退回', '審核通過'),

export const APPROVAL_STATUS = {
  PENDING: "待審核",
  REVIEWING: "審核中",
  REJECTED: "審核退回",
  APPROVED: "審核通過",
};

export const APPROVAL_STATUS_COLOR = {
  [APPROVAL_STATUS.PENDING]: "grey",
  [APPROVAL_STATUS.REVIEWING]: "amber",
  [APPROVAL_STATUS.REJECTED]: "red",
  [APPROVAL_STATUS.APPROVED]: "green",
};

export const EMPLOYMENT_TYPE = {
  1: "全工時",
  2: "部份工時",
};

export const CONTRACT_WORK_TYPE = {
  0: "未設定",
  1: "定期契約",
  2: "非定期契約",
};

export const CONTRACT_TYPE = {
  1: "定期",
  2: "非定期",
};

export const SALARY_TYPE = {
  0: "未設定",
  1: "月薪",
  2: "時薪",
  // 3: "日薪",
};

export const SALARY_PAYMENT_FREQUENCY = {
  1: "月結",
  2: "週結",
  3: "日結",
};

export const HOURLY_SALARY_TYPE = {
  1: "排班(班表)",
  2: "約定時段",
  3: "約定時數",
};

export const PART_TIME_TYPE = {
  1: "月薪制",
  2: "時薪排班",
  3: "時薪約定-固定時段",
  4: "時薪約定-固定時數",
};

export const SCHEDULE_TYPE = {
  GENERAL: "GENERAL",
  BIWEEKLY_FLEX: "BIWEEKLY_FLEX",
  FOURWEEK_FLEX: "FOURWEEK_FLEX",
};

export const DEFAULT_PASSWORD = "abcd_123456";
